import { api } from "./api";
import type { BirdSale } from "@/types/models";
import type { SalePaymentLine } from "@/hooks/useSalePayments";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const birdSaleService = {
  create: (data: {
    flock_id?: number;
    date: string;
    bird_count: number;
    total_weight_kg?: number;
    rate_per_kg?: number;
    rate_per_bird?: number;
    total_amount: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    notes?: string;
    payments?: SalePaymentLine[];
  }) =>
    api
      .post<{ success: boolean; data: BirdSale }>("/bird-sales", data)
      .then((r) => r.data),
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<BirdSale>>("/bird-sales", { params })
      .then((r) => r.data),
  get: (id: number) =>
    api
      .get<{ success: boolean; data: BirdSale }>(`/bird-sales/${id}`)
      .then((r) => r.data),
  update: (id: number, data: {
    flock_id?: number;
    date: string;
    bird_count: number;
    total_weight_kg?: number;
    rate_per_kg?: number;
    rate_per_bird?: number;
    total_amount: number;
    buyer_id?: number;
    /** Owner-only approval for a sale that breaches the buyer's credit terms. */
    credit_override?: boolean;
    notes?: string;
  }) =>
    api
      .put<{ success: boolean; data: BirdSale }>(`/bird-sales/${id}`, data)
      .then((r) => r.data),
  // confirmPaid: the owner has seen "money has been paid on this sale" and
  // said delete.
  delete: (id: number, confirmPaid = false) =>
    api.delete(`/bird-sales/${id}`, { params: confirmPaid ? { confirm_paid: "true" } : undefined }).then((r) => r.data),
};
